import React, { useState } from 'react';
import { Send, CheckCircle } from 'lucide-react';
export function FreeTrialContent() {
  const [formState, setFormState] = useState<'idle' | 'submitting' | 'success'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFormState('submitting');
    setTimeout(() => {
      setFormState('success');
    }, 1500);
  };
  return <section className="py-12 bg-[#0a0a0a]" data-id="element-839">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-840">
        <div className="bg-[#1a1a1a] rounded-3xl shadow-2xl overflow-hidden border border-gray-800" data-id="element-841">
          <div className="p-8 md:p-12" data-id="element-842">
            {formState === 'success' ? <div className="animate-scale-in h-full flex flex-col items-center justify-center text-center p-6" data-id="element-843">
                <div className="w-16 h-16 bg-green-100 text-green-500 rounded-full flex items-center justify-center mb-4" data-id="element-844">
                  <CheckCircle size={32} data-id="element-845" />
                </div>
                <h4 className="text-2xl font-bold text-white mb-2" data-id="element-846">
                  Request Sent!
                </h4>
                <p className="text-gray-400" data-id="element-847">
                  We'll be in touch shortly to schedule your free week.
                </p>
                <button onClick={() => setFormState('idle')} className="mt-8 text-[#00D4FF] font-bold hover:underline" data-id="element-848">
                  Send another request
                </button>
              </div> : <>
                <div className="mb-10 space-y-6 text-gray-300 leading-relaxed" data-id="element-849">
                  <p data-id="element-850">
                    Perhaps you want to get fit or ensure the safety of yourself
                    and your family in today's world. The journey towards
                    physical fitness and personal safety can start with a single
                    thought: the desire for positive change.
                  </p>
                  <p data-id="element-851">
                    Walker's Martial Arts offers a structured way to achieve
                    these goals. By engaging in regular practice, you can
                    improve your physical fitness through skill development,
                    strength training, and cardiovascular conditioning. The
                    intensity of martial arts workouts will enhance your
                    stamina, flexibility, and overall health.
                  </p>
                  <p data-id="element-852">
                    In addition to fitness, martial arts training equips you
                    with self-defense techniques, empowering you to respond
                    effectively in potentially dangerous situations. This
                    training not only builds physical skills but also fosters
                    mental discipline and confidence.
                  </p>
                  <p data-id="element-853">
                    Get involved with a supportive community, where you and your
                    family can grow together in skills, fitness, and safety.
                    Every class provides a unique opportunity to learn,
                    practice, and build resilience.
                  </p>
                  <p className="font-semibold text-white" data-id="element-854">
                    The idea of getting fit and staying safe can transform into
                    a rewarding reality. Start your journey today.
                  </p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-6" data-id="element-855">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-856">
                    <div data-id="element-857">
                      <label htmlFor="firstName" className="block text-sm font-medium text-gray-400 mb-2" data-id="element-858">
                        First Name <span className="text-red-500" data-id="element-859">*</span>
                      </label>
                      <input type="text" id="firstName" required className="w-full px-4 py-3 rounded-lg border border-gray-700 bg-black text-white focus:ring-2 focus:ring-[#00D4FF] focus:border-transparent outline-none transition-all" placeholder="First Name" data-id="element-860" />
                    </div>
                    <div data-id="element-861">
                      <label htmlFor="lastName" className="block text-sm font-medium text-gray-400 mb-2" data-id="element-862">
                        Last Name <span className="text-red-500" data-id="element-863">*</span>
                      </label>
                      <input type="text" id="lastName" required className="w-full px-4 py-3 rounded-lg border border-gray-700 bg-black text-white focus:ring-2 focus:ring-[#00D4FF] focus:border-transparent outline-none transition-all" placeholder="Last Name" data-id="element-864" />
                    </div>
                  </div>
                  <div data-id="element-865">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-400 mb-2" data-id="element-866">
                      Email <span className="text-red-500" data-id="element-867">*</span>
                    </label>
                    <input type="email" id="email" required className="w-full px-4 py-3 rounded-lg border border-gray-700 bg-black text-white focus:ring-2 focus:ring-[#00D4FF] focus:border-transparent outline-none transition-all" placeholder="Email" data-id="element-868" />
                  </div>
                  <div data-id="element-869">
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-400 mb-2" data-id="element-870">
                      Phone <span className="text-red-500" data-id="element-871">*</span>
                    </label>
                    <input type="tel" id="phone" required className="w-full px-4 py-3 rounded-lg border border-gray-700 bg-black text-white focus:ring-2 focus:ring-[#00D4FF] focus:border-transparent outline-none transition-all" placeholder="Phone" data-id="element-872" />
                  </div>
                  <div data-id="element-873">
                    <label htmlFor="class" className="block text-sm font-medium text-gray-400 mb-2" data-id="element-874">
                      What class would you like to try?{' '}
                      <span className="text-red-500" data-id="element-875">*</span>
                    </label>
                    <select id="class" required className="w-full px-4 py-3 rounded-lg border border-gray-700 bg-black text-white focus:ring-2 focus:ring-[#00D4FF] focus:border-transparent outline-none transition-all" data-id="element-876">
                      <option value="" data-id="element-877">Select an option</option>
                      <option value="taekwondo" data-id="element-878">Taekwondo</option>
                      <option value="kickboxing" data-id="element-879">Kickboxing</option>
                    </select>
                  </div>
                  <div data-id="element-880">
                    <label htmlFor="details" className="block text-sm font-medium text-gray-400 mb-2" data-id="element-881">
                      Please provide name(s), age(s) & date you would like to
                      start
                    </label>
                    <textarea id="details" rows={4} className="w-full px-4 py-3 rounded-lg border border-gray-700 bg-black text-white focus:ring-2 focus:ring-[#00D4FF] focus:border-transparent outline-none transition-all resize-none" placeholder="Enter details here..." data-id="element-882" />
                  </div>
                  <button type="submit" disabled={formState === 'submitting'} className="w-full bg-[#00D4FF] text-black font-bold py-4 rounded-lg uppercase tracking-wider hover:bg-[#33ddff] transition-colors flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed shadow-[0_0_20px_rgba(0,212,255,0.3)]" data-id="element-883">
                    {formState === 'submitting' ? 'Sending...' : 'Send'}
                    {formState === 'idle' && <Send size={18} data-id="element-884" />}
                  </button>
                </form>
              </>}
          </div>
        </div>
      </div>
    </section>;
}